export enum MonitoringRouteEnum {
  Monitoring = '/home/monitoring',
  TaskMonitoring = '/home/monitoring/tasks',
}
